__turbopack_context__.v({
  "audience-tag": "OfferCard-module-scss-module__zTLpNG__audience-tag",
  "badge": "OfferCard-module-scss-module__zTLpNG__badge",
  "badge-container": "OfferCard-module-scss-module__zTLpNG__badge-container",
  "container": "OfferCard-module-scss-module__zTLpNG__container",
  "content": "OfferCard-module-scss-module__zTLpNG__content",
  "content-text": "OfferCard-module-scss-module__zTLpNG__content-text",
  "cta-container": "OfferCard-module-scss-module__zTLpNG__cta-container",
  "description": "OfferCard-module-scss-module__zTLpNG__description",
  "modal-text": "OfferCard-module-scss-module__zTLpNG__modal-text",
  "promotional-badge": "OfferCard-module-scss-module__zTLpNG__promotional-badge",
  "promotional-badge__content": "OfferCard-module-scss-module__zTLpNG__promotional-badge__content",
  "see-details-trigger": "OfferCard-module-scss-module__zTLpNG__see-details-trigger",
  "title": "OfferCard-module-scss-module__zTLpNG__title",
});
